import type { AuthService } from "../auth/auth-service";
import { config } from "../config";

/** A generation awaiting QA review (matches the API's snake_case wire shape). */
export interface ReviewItem {
  id: string;
  operation: string;
  target_metal: string | null;
  ring_sku: string;
  source_image_url: string;
  output_image_url: string | null;
  descriptor: string;
  qa_score: number | null;
  created_at: string;
  completed_at: string | null;
}

const base = config.ringSwapPrefix; // e.g. "/ring-swap" on the gateway

export async function fetchReviewQueue(service: AuthService): Promise<ReviewItem[]> {
  const res = await service.authFetch(`${base}/v1/admin/generations?status=needs_review`);
  if (!res.ok) throw new Error(`failed to load review queue: HTTP ${res.status}`);
  const body = (await res.json()) as { items: ReviewItem[] };
  return body.items;
}

export async function submitReview(
  service: AuthService,
  id: string,
  decision: "approve" | "reject",
): Promise<void> {
  const res = await service.authFetch(`${base}/v1/admin/generations/${id}/review`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ decision }),
  });
  if (!res.ok) throw new Error(`review failed: HTTP ${res.status}`);
}
